import React from "react"
import "./product.scss";
import ModalImage from "react-modal-image";


const product = (props)=>{
  return(
    <div className="product text" >
      <ModalImage hideZoom={true} showRotate={false} alt={props.name} hideDownload={true} small={props.img} large={props.img} />
      <div className="times title">{props.name}</div>
      <div className="description">{props.description}</div>
    </div>
  )
}
export default product;
